module.exports = __webpack_public_path__ + "media/images/p-about/example/okueigenji-8de24527796eb8c31178b02da5dd6beb.jpg";